import { useEffect, useRef } from 'react';

import { isIOSDevice } from '../DeviceDetector';
import { EventBusEvent } from '../enums/EventBus';
import eventBus from '../event-bus/EventBus';
import { getCurrentUrl } from '../utils/url';

interface Args {
  isOpen: boolean;
  onClose?: () => void;
  toggleEvent?: EventBusEvent;
  skipToggleEvent?: boolean;
}

export const useBackNavigationOnClose = () => {
  const handleNavigationOnManualClose = () => {
    history.back();
  };

  return { onManualClose: handleNavigationOnManualClose };
};

export const useBackNavigation = ({
  isOpen,
  onClose,
  toggleEvent = EventBusEvent.ToggleDrawer,
  skipToggleEvent = false,
}: Args) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    const popstateHandler = () => {
      if (!skipToggleEvent) {
        eventBus.emit(toggleEvent, {
          open: false,
          transitionDisabled: isIOSDevice(),
        });
      }

      onCloseRef.current?.();
    };

    if (isOpen) {
      history.pushState(null, '', getCurrentUrl());
      window.addEventListener('popstate', popstateHandler);
    }

    return () => {
      window.removeEventListener('popstate', popstateHandler);
    };
  }, [isOpen, toggleEvent, skipToggleEvent]);

  const { onManualClose } = useBackNavigationOnClose();

  return { onManualClose };
};
